import { __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import classnames from 'classnames';
import CampingIcon from './camping.svg.js';
import CuratedInternalIcon from './curated-internal.svg.js';
import CyclingIcon from './cycling.svg.js';
import FishingIcon from './fishing.svg.js';
import GolfIcon from './golf.svg.js';
import JetChartersIcon from './jet-charters.svg.js';
import JewelryIcon from './jewelry.svg.js';
import WinterSportsIcon from './winter-sports.svg.js';
import YachtChartersIcon from './yacht-charters.svg.js';
import styles from './styles.css.js';

var DepartmentIcon = function DepartmentIcon(_a) {
  var departmentSlug = _a.departmentSlug,
      color = _a.color,
      _b = _a.strokeWidth,
      strokeWidth = _b === void 0 ? 0 : _b,
      className = _a.className,
      rest = __rest(_a, ["departmentSlug", "color", "strokeWidth", "className"]);

  var sharedProps = {
    className: classnames(styles.icon, className),
    strokeWidth: strokeWidth,
    color: color
  };

  switch (departmentSlug) {
    case 'golf':
      return React.createElement(GolfIcon, __assign({}, sharedProps, rest));

    case 'cycling':
      return React.createElement(CyclingIcon, __assign({}, sharedProps, rest));

    case 'jewelry':
      return React.createElement(JewelryIcon, __assign({}, sharedProps, rest));

    case 'winter-sports':
      return React.createElement(WinterSportsIcon, __assign({}, sharedProps, rest));

    case 'yacht-charters':
      return React.createElement(YachtChartersIcon, __assign({}, sharedProps, rest));

    case 'jet-charters':
      return React.createElement(JetChartersIcon, __assign({}, sharedProps, rest));

    case 'camping':
      return React.createElement(CampingIcon, __assign({}, sharedProps, rest));

    case 'fishing':
      return React.createElement(FishingIcon, __assign({}, sharedProps, rest));

    case 'curated-internal':
      return React.createElement(CuratedInternalIcon, __assign({}, sharedProps, rest));

    default:
      console.error("Unrecognized department passed to DepartmentIcon component [" + departmentSlug + "]");
      return null;
  }
};

export default DepartmentIcon;
//# sourceMappingURL=index.js.map
